// Read more for collection description
const collectionDesc = document.querySelector('.collection-hero__description');
if (collectionDesc) {
  const btn = document.createElement('button');
  btn.className = 'read-more-btn';
  btn.textContent = 'Read more';
  collectionDesc.insertAdjacentElement('afterend', btn);

  btn.addEventListener('click', function() {
    collectionDesc.classList.toggle('expanded');
    btn.textContent = collectionDesc.classList.contains('expanded') ? 'Read less' : 'Read more';
  });
}